import React from 'react';

const UploadCard = ({ icon, title, desc, type, inputRef, accept, handleFileUpload }) => (
  <div style={{
    backgroundColor: 'var(--card-bg)', padding: '0.75rem', borderRadius: '4px',
    boxShadow: '0 1px 2px rgba(0,0,0,0.08)', borderLeft: '3px solid var(--info)',
    display: 'flex', alignItems: 'center', gap: '0.75rem', cursor: 'pointer'
  }} onClick={() => inputRef.current?.click()}>
    <div style={{ fontSize: '1.5rem' }}>{icon}</div>
    <div style={{ flex: 1 }}>
      <div style={{ fontWeight: '600', fontSize: '12px' }}>{title}</div>
      <div style={{ fontSize: '10px', color: 'var(--text-muted)' }}>{desc}</div>
    </div>
    <input ref={inputRef} type="file" accept={accept} style={{ display: 'none' }}
      onChange={e => { handleFileUpload(type, e.target.files[0]); e.target.value = ''; }} />
    <button style={{
      padding: '4px 10px', fontSize: '11px', border: '1px solid var(--primary)',
      color: 'var(--primary)', cursor: 'pointer', fontWeight: '500'
    }}>Import</button>
  </div>
);

const PdfUploadCard = ({ icon, title, desc, type, inputRef, accept, onPdfSelect, pendingPdfFile, pendingPdfType }) => {
  const isThisType = pendingPdfType === type;
  const hasFile = isThisType && pendingPdfFile;
  return (
    <div style={{
      backgroundColor: hasFile ? 'var(--success-bg, rgba(40,167,69,0.08))' : 'var(--card-bg)',
      padding: '0.75rem', borderRadius: '4px',
      boxShadow: '0 1px 2px rgba(0,0,0,0.08)',
      borderLeft: `3px solid ${hasFile ? 'var(--success)' : 'var(--info)'}`,
      display: 'flex', alignItems: 'center', gap: '0.75rem', cursor: 'pointer'
    }} onClick={() => inputRef.current?.click()}>
      <div style={{ fontSize: '1.5rem' }}>{icon}</div>
      <div style={{ flex: 1 }}>
        <div style={{ fontWeight: '600', fontSize: '12px' }}>{title}</div>
        {hasFile ? (
          <div style={{ fontSize: '10px', color: 'var(--success)', fontWeight: '500' }}>
            {pendingPdfFile.name}
          </div>
        ) : (
          <div style={{ fontSize: '10px', color: 'var(--text-muted)' }}>{desc}</div>
        )}
      </div>
      <input ref={inputRef} type="file" accept={accept} style={{ display: 'none' }}
        onChange={e => { onPdfSelect(type, e.target.files[0]); e.target.value = ''; }} />
      <button style={{
        padding: '4px 10px', fontSize: '11px',
        border: `1px solid ${hasFile ? 'var(--success)' : 'var(--primary)'}`,
        color: hasFile ? 'var(--success)' : 'var(--primary)', cursor: 'pointer', fontWeight: '500'
      }}>{hasFile ? 'Zmien' : 'Wybierz PDF'}</button>
    </div>
  );
};

// Karta kreatora — jedyna opcja widoczna dla kasjera
const KreatorCard = ({ onOpenKreator }) => (
  <div style={{
    backgroundColor: 'var(--success-light)', padding: '0.75rem', borderRadius: '4px',
    boxShadow: '0 1px 2px rgba(0,0,0,0.08)', borderLeft: '3px solid var(--success)',
    display: 'flex', alignItems: 'center', gap: '0.75rem', cursor: 'pointer'
  }} onClick={onOpenKreator}>
    <div style={{ fontSize: '1.5rem' }}>🧭</div>
    <div style={{ flex: 1 }}>
      <div style={{ fontWeight: '600', fontSize: '12px' }}>Kreator dodawania faktury</div>
      <div style={{ fontSize: '10px', color: 'var(--text-muted)' }}>Cennik, potem faktura — krok po kroku</div>
    </div>
    {/* BEZ inline backgroundColor: motyw (v3sys-theme.css) nadaje przyciskom bez
        wlasnego tla czytelny outline var(--text-secondary). Z inline tlem przycisk
        wypadal z tego wyjatku i zostawal zielonym napisem 2.28:1 na bialym,
        czyli najgorzej czytelnym przyciskiem w calym panelu. */}
    <button onClick={e => { e.stopPropagation(); onOpenKreator?.(); }} style={{
      padding: '4px 10px', fontSize: '11px', border: '1px solid var(--success)',
      cursor: 'pointer', fontWeight: '600'
    }}>Otwórz</button>
  </div>
);

const ImportPanel = ({
  // Gating panelu — kasjer widzi tylko kreator
  pokazZaawansowane, uprawnieniaLaduja, onOpenKreator,
  xmlInputRef, paragonInputRef, pdfInputRef, pdfProductsInputRef, cennikInputRef,
  cennikMultipleInputRef, optimaInputRef, sfdInputRef, xmlValidationInputRef,
  handleFileUpload, handleOptimaUpload, handleSfdUpload,
  handleMultipleCennikUpload,
  // Zbiorczy import paragonow (kilka plikow naraz, zapis od razu)
  paragonMultipleInputRef, handleMultipleParagonUpload,
  updateProductNames, setUpdateProductNames,
  pendingPdfFile, pendingPdfType, onPdfSelect, onXmlValidationSelect, onPdfImportStart,
  // Aktualizacja cen z XML
  optimaUpdateCennikRef, optimaUpdateDokumentRef,
  optimaUpdateCennikFile, optimaUpdateDokumentFile,
  onOptimaUpdateCennik, onOptimaUpdateDokument, onOptimaUpdateImport,
  // Cennik only
  cennikOnlyFile, onCennikOnlyFileChange, onCennikOnlyImport,
  // CSV + XML pricelist
  csvXmlCsvFile, setCsvXmlCsvFile, csvXmlXmlFile, setCsvXmlXmlFile, handleCsvXmlImport,
}) => {
  const hasPdf = !!pendingPdfFile;
  return (
    <div style={{ backgroundColor: 'var(--card-bg)', borderRadius: '4px', boxShadow: '0 1px 2px rgba(0,0,0,0.08)', overflow: 'hidden' }}>
      <div style={{ padding: '0.5rem 0.75rem', borderBottom: '1px solid var(--border)', fontWeight: '600', fontSize: '12px', backgroundColor: 'var(--bg)' }}>
        Import faktur
      </div>
      <div style={{ padding: '0.5rem', display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
        {/* Kreator — zawsze widoczny, dla kasjera jedyna opcja */}
        <KreatorCard onOpenKreator={onOpenKreator} />

        {/* Sekcja zaawansowana — tylko admin / faktury_zakupu.import_zaawansowany.
            Podczas ladowania uprawnien NIE renderujemy jej wcale, zeby kasjerowi
            nie mrugnely opcje administracyjne. */}
        {!uprawnieniaLaduja && pokazZaawansowane && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', borderTop: '1px solid var(--border)', paddingTop: '0.5rem', marginTop: '0.25rem' }}>
        <div style={{ fontSize: '10px', fontWeight: '600', color: 'var(--text-muted)' }}>
          Opcje zaawansowane (administrator)
        </div>
        {/* Grupa XML */}
        <div style={{ border: '1px solid var(--info)', borderRadius: '6px', padding: '0.5rem', backgroundColor: 'var(--bg)' }}>
          <div style={{ fontSize: '10px', fontWeight: '600', color: 'var(--primary)', marginBottom: '0.4rem', display: 'flex', alignItems: 'center', gap: '0.3rem' }}>
            Dokumenty XML
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.4rem' }}>
            <UploadCard icon="📋" title="Import faktury XML" desc="Faktury w formacie XML/UBL/Optima" type="xml" inputRef={xmlInputRef} accept=".xml" handleFileUpload={handleFileUpload} />
            <UploadCard icon="💰" title="Import cennika XML" desc="Cennik dostawcy w formacie XML" type="cennik" inputRef={cennikInputRef} accept=".xml" handleFileUpload={handleFileUpload} />
            {/* Import wielu cennikow */}
            <div style={{
              backgroundColor: 'var(--card-bg)', padding: '0.75rem', borderRadius: '4px',
              boxShadow: '0 1px 2px rgba(0,0,0,0.08)', borderLeft: '3px solid var(--success)',
              display: 'flex', alignItems: 'center', gap: '0.75rem', cursor: 'pointer'
            }} onClick={() => cennikMultipleInputRef.current?.click()}>
              <div style={{ fontSize: '1.5rem' }}>📚</div>
              <div style={{ flex: 1 }}>
                <div style={{ fontWeight: '600', fontSize: '12px' }}>Import wielu cenników</div>
                <div style={{ fontSize: '10px', color: 'var(--text-muted)' }}>Zaznacz kilka plików XML naraz</div>
              </div>
              <input ref={cennikMultipleInputRef} type="file" accept=".xml" multiple style={{ display: 'none' }}
                onChange={e => { handleMultipleCennikUpload(e.target.files); e.target.value = ''; }} />
              <button style={{
                padding: '4px 10px', fontSize: '11px', border: '1px solid var(--success)',
                color: 'var(--success)', cursor: 'pointer', fontWeight: '500'
              }}>Importuj wiele</button>
            </div>
          </div>
        </div>

        {/* Grupa paragonow: pojedynczy (z podgladem) + zbiorczy (zapis od razu) */}
        <div style={{ border: '1px solid var(--info)', borderRadius: '6px', padding: '0.5rem', backgroundColor: 'var(--bg)' }}>
          <div style={{ fontSize: '10px', fontWeight: '600', color: 'var(--primary)', marginBottom: '0.4rem' }}>
            Paragony z NIP (XML)
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.4rem' }}>
            <UploadCard icon="🧾" title="Import XML paragon" desc="Jeden paragon, z podglądem przed zapisem" type="paragon" inputRef={paragonInputRef} accept=".xml" handleFileUpload={handleFileUpload} />
            <div style={{
              backgroundColor: 'var(--card-bg)', padding: '0.75rem', borderRadius: '4px',
              boxShadow: '0 1px 2px rgba(0,0,0,0.08)', borderLeft: '3px solid var(--success)',
              display: 'flex', alignItems: 'center', gap: '0.75rem', cursor: 'pointer'
            }} onClick={() => paragonMultipleInputRef?.current?.click()}>
              <div style={{ fontSize: '1.5rem' }}>🗂️</div>
              <div style={{ flex: 1 }}>
                <div style={{ fontWeight: '600', fontSize: '12px' }}>Import wielu paragonów</div>
                <div style={{ fontSize: '10px', color: 'var(--text-muted)' }}>Zaznacz kilka plików XML — zapis od razu, duplikaty pomijane</div>
              </div>
              <input ref={paragonMultipleInputRef} type="file" accept=".xml" multiple style={{ display: 'none' }}
                data-testid="paragon-multi-input"
                onChange={e => { handleMultipleParagonUpload?.(e.target.files); e.target.value = ''; }} />
              <button style={{
                padding: '4px 10px', fontSize: '11px', border: '1px solid var(--success)',
                color: 'var(--success)', cursor: 'pointer', fontWeight: '500'
              }}>Importuj wiele</button>
            </div>
          </div>
        </div>

        {/* Aktualizacja cen z XML */}
        <div style={{ border: '1px solid var(--warning)', borderRadius: '6px', padding: '0.5rem', backgroundColor: 'var(--bg)' }}>
          <div style={{ fontSize: '10px', fontWeight: '600', color: 'var(--warning)', marginBottom: '0.4rem' }}>
            Aktualizacja cen z XML (cennik + dokument)
          </div>
          <div style={{ fontSize: '10px', color: 'var(--text-muted)', marginBottom: '0.4rem' }}>
            Wgraj 2 pliki z Optima: cennik (nazwy + ceny detaliczne) + dokument (ceny zakupu). Aktualizuje istniejące produkty bez tworzenia faktury.
          </div>
          <div style={{ display: 'flex', gap: '0.4rem' }}>
            <div style={{ flex: 1 }}>
              <input ref={optimaUpdateCennikRef} type="file" accept=".xml" style={{ display: 'none' }}
                onChange={e => { if (e.target.files[0]) onOptimaUpdateCennik(e.target.files[0]); e.target.value = ''; }} />
              <button onClick={() => optimaUpdateCennikRef.current?.click()} style={{
                width: '100%', padding: '6px 12px', fontSize: '12px', cursor: 'pointer',
                border: optimaUpdateCennikFile ? '2px solid var(--success)' : '1px solid var(--border)',
                backgroundColor: optimaUpdateCennikFile ? 'var(--success-light)' : 'var(--card-bg)',
                color: optimaUpdateCennikFile ? 'var(--success)' : 'var(--text-secondary)'
              }}>
                {optimaUpdateCennikFile ? `✓ ${optimaUpdateCennikFile.name.substring(0, 20)}` : '📋 Cennik XML'}
              </button>
            </div>
            <div style={{ flex: 1 }}>
              <input ref={optimaUpdateDokumentRef} type="file" accept=".xml" style={{ display: 'none' }}
                onChange={e => { if (e.target.files[0]) onOptimaUpdateDokument(e.target.files[0]); e.target.value = ''; }} />
              <button onClick={() => optimaUpdateDokumentRef.current?.click()} style={{
                width: '100%', padding: '6px 12px', fontSize: '12px', cursor: 'pointer',
                border: optimaUpdateDokumentFile ? '2px solid var(--success)' : '1px solid var(--border)',
                backgroundColor: optimaUpdateDokumentFile ? 'var(--success-light)' : 'var(--card-bg)',
                color: optimaUpdateDokumentFile ? 'var(--success)' : 'var(--text-secondary)'
              }}>
                {optimaUpdateDokumentFile ? `✓ ${optimaUpdateDokumentFile.name.substring(0, 20)}` : '📄 Dokument XML'}
              </button>
            </div>
          </div>
          {optimaUpdateCennikFile && optimaUpdateDokumentFile && (
            <button onClick={onOptimaUpdateImport} style={{
              width: '100%', marginTop: '0.4rem', padding: '6px 12px', fontSize: '12px', fontWeight: '600',
              border: '2px solid var(--warning)', cursor: 'pointer',
              color: 'var(--warning)', backgroundColor: 'var(--card-bg)'
            }}>
              Aktualizuj ceny
            </button>
          )}
        </div>

        {/* Grupa Cennik XML — aktualizacja cen detalicznych + VAT */}
        <div style={{ border: '1px solid var(--purple, #6f42c1)', borderRadius: '6px', padding: '0.5rem', backgroundColor: 'var(--bg)' }}>
          <div style={{ fontSize: '10px', fontWeight: '600', color: 'var(--purple, #6f42c1)', marginBottom: '0.4rem', display: 'flex', alignItems: 'center', gap: '0.3rem' }}>
            Aktualizuj z cennika XML
          </div>
          <div style={{
            backgroundColor: cennikOnlyFile ? 'rgba(111,66,193,0.08)' : 'var(--card-bg)',
            padding: '0.75rem', borderRadius: '4px', boxShadow: '0 1px 2px rgba(0,0,0,0.08)',
            borderLeft: '3px solid var(--purple, #6f42c1)', display: 'flex', alignItems: 'center', gap: '0.75rem',
            cursor: 'pointer'
          }} onClick={() => document.getElementById('cennik-only-xml')?.click()}>
            <div style={{ fontSize: '1.5rem' }}>📊</div>
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: '600', fontSize: '12px' }}>Cennik XML</div>
              <div style={{ fontSize: '10px', color: 'var(--text-muted)' }}>
                {cennikOnlyFile ? cennikOnlyFile.name : 'Aktualizacja cen detalicznych i VAT'}
              </div>
            </div>
            <input id="cennik-only-xml" type="file" accept=".xml" style={{ display: 'none' }}
              onChange={e => { onCennikOnlyFileChange(e.target.files[0]); e.target.value = ''; }} />
            <button style={{
              padding: '4px 10px', fontSize: '11px', border: '1px solid var(--purple, #6f42c1)',
              color: 'var(--purple, #6f42c1)', cursor: 'pointer', fontWeight: '500', backgroundColor: 'var(--card-bg)'
            }}>{cennikOnlyFile ? 'Zmień' : 'Wybierz'}</button>
          </div>
          {cennikOnlyFile && (
            <button onClick={onCennikOnlyImport} style={{
              width: '100%', marginTop: '0.4rem', padding: '6px 12px', fontSize: '12px', fontWeight: '600',
              border: '2px solid var(--purple, #6f42c1)', cursor: 'pointer',
              color: 'var(--purple, #6f42c1)', backgroundColor: 'var(--card-bg)'
            }}>
              Aktualizuj z cennika
            </button>
          )}
        </div>

        {/* CSV + XML Cennik (laczenie 2 zrodel po EAN) */}
        <div style={{ border: '1px solid var(--teal, #20c997)', borderRadius: '6px', padding: '0.5rem', backgroundColor: 'var(--bg)' }}>
          <div style={{ fontSize: '10px', fontWeight: '600', color: 'var(--teal, #20c997)', marginBottom: '0.4rem', display: 'flex', alignItems: 'center', gap: '0.3rem' }}>
            Import CSV + XML cennika
          </div>
          <div style={{ fontSize: '10px', color: 'var(--text-muted)', marginBottom: '0.4rem' }}>
            CSV (ceny zakupu netto + nazwy) + XML Optima (ceny detaliczne + VAT). Mapowanie po EAN.
          </div>
          <div style={{ display: 'flex', gap: '0.4rem' }}>
            <div style={{ flex: 1 }}>
              <input id="csv-xml-csv" type="file" accept=".csv,.txt" style={{ display: 'none' }}
                onChange={e => { if (e.target.files[0]) setCsvXmlCsvFile(e.target.files[0]); e.target.value = ''; }} />
              <button onClick={() => document.getElementById('csv-xml-csv')?.click()} style={{
                width: '100%', padding: '6px 12px', fontSize: '12px', cursor: 'pointer',
                border: csvXmlCsvFile ? '2px solid var(--success)' : '1px solid var(--border)',
                backgroundColor: csvXmlCsvFile ? 'var(--success-light)' : 'var(--card-bg)',
                color: csvXmlCsvFile ? 'var(--success)' : 'var(--text-secondary)'
              }}>
                {csvXmlCsvFile ? `✓ ${csvXmlCsvFile.name.substring(0, 25)}` : '📋 CSV (ceny zakupu)'}
              </button>
            </div>
            <div style={{ flex: 1 }}>
              <input id="csv-xml-xml" type="file" accept=".xml" style={{ display: 'none' }}
                onChange={e => { if (e.target.files[0]) setCsvXmlXmlFile(e.target.files[0]); e.target.value = ''; }} />
              <button onClick={() => document.getElementById('csv-xml-xml')?.click()} style={{
                width: '100%', padding: '6px 12px', fontSize: '12px', cursor: 'pointer',
                border: csvXmlXmlFile ? '2px solid var(--success)' : '1px solid var(--border)',
                backgroundColor: csvXmlXmlFile ? 'var(--success-light)' : 'var(--card-bg)',
                color: csvXmlXmlFile ? 'var(--success)' : 'var(--text-secondary)'
              }}>
                {csvXmlXmlFile ? `✓ ${csvXmlXmlFile.name.substring(0, 25)}` : '📄 XML (cennik detal.)'}
              </button>
            </div>
          </div>
          {(csvXmlCsvFile || csvXmlXmlFile) && (
            <button onClick={handleCsvXmlImport} style={{
              width: '100%', marginTop: '0.4rem', padding: '6px 12px', fontSize: '12px', fontWeight: '600',
              border: '2px solid var(--teal, #20c997)', cursor: 'pointer',
              color: 'var(--teal, #20c997)', backgroundColor: 'var(--card-bg)'
            }}>
              Importuj i podglad
            </button>
          )}
        </div>

        {/* Grupa PDF — wymaga PDF + XML walidacyjny */}
        <div style={{ border: '1px solid var(--info)', borderRadius: '6px', padding: '0.5rem', backgroundColor: 'var(--bg)' }}>
          <div style={{ fontSize: '10px', fontWeight: '600', color: 'var(--primary)', marginBottom: '0.4rem', display: 'flex', alignItems: 'center', gap: '0.3rem' }}>
            Dokumenty PDF + XML walidacyjny
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.4rem' }}>
            {/* Krok 1: Wybierz PDF */}
            <PdfUploadCard
              icon="📋" title="Import faktury PDF" desc="Faktura zakupowa z pliku PDF"
              type="pdf" inputRef={pdfInputRef} accept=".pdf"
              onPdfSelect={onPdfSelect} pendingPdfFile={pendingPdfFile} pendingPdfType={pendingPdfType}
            />
            <PdfUploadCard
              icon="🛒" title="Import produktów z PDF" desc="Tylko produkty i ceny, bez faktury"
              type="pdf-products" inputRef={pdfProductsInputRef} accept=".pdf"
              onPdfSelect={onPdfSelect} pendingPdfFile={pendingPdfFile} pendingPdfType={pendingPdfType}
            />

            {/* Krok 2: Wybierz XML walidacyjny (widoczny po wybraniu PDF) */}
            {hasPdf && (
              <div style={{
                backgroundColor: 'var(--card-bg)', padding: '0.75rem', borderRadius: '4px',
                boxShadow: '0 1px 2px rgba(0,0,0,0.08)', borderLeft: '3px solid var(--warning, #ffc107)',
                display: 'flex', alignItems: 'center', gap: '0.75rem', cursor: 'pointer',
                animation: 'fadeIn 0.2s ease-in'
              }} onClick={() => xmlValidationInputRef.current?.click()}>
                <div style={{ fontSize: '1.5rem' }}>📄</div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: '600', fontSize: '12px' }}>
                    Wybierz plik XML walidacyjny
                  </div>
                  <div style={{ fontSize: '10px', color: 'var(--text-muted)' }}>
                    Plik OSOZ-EDI od dostawcy (wymagany)
                  </div>
                </div>
                <input ref={xmlValidationInputRef} type="file" accept=".xml" style={{ display: 'none' }}
                  onChange={e => { onXmlValidationSelect(e.target.files[0]); e.target.value = ''; }} />
                <button style={{
                  padding: '4px 10px', fontSize: '11px',
                  border: '1px solid var(--warning, #ffc107)',
                  color: 'var(--warning, #ffc107)', cursor: 'pointer', fontWeight: '500'
                }}>Wybierz XML</button>
              </div>
            )}
          </div>
          <label style={{
            display: 'flex', alignItems: 'center', gap: '0.5rem', marginTop: '0.5rem',
            fontSize: '11px', color: 'var(--text-secondary)', cursor: 'pointer', paddingLeft: '0.25rem'
          }} onClick={e => e.stopPropagation()}>
            <input
              type="checkbox"
              checked={updateProductNames}
              onChange={e => setUpdateProductNames(e.target.checked)}
              style={{ width: '14px', height: '14px', cursor: 'pointer' }}
            />
            Aktualizuj nazwy produktów
          </label>
        </div>

        {/* Import Optima XLS */}
        <div style={{
          backgroundColor: 'var(--card-bg)', padding: '0.75rem', borderRadius: '4px',
          boxShadow: '0 1px 2px rgba(0,0,0,0.08)', borderLeft: '3px solid var(--success)',
          display: 'flex', alignItems: 'center', gap: '0.75rem', cursor: 'pointer'
        }} onClick={() => optimaInputRef.current?.click()}>
          <div style={{ fontSize: '1.5rem' }}>📦</div>
          <div style={{ flex: 1 }}>
            <div style={{ fontWeight: '600', fontSize: '12px' }}>Import magazynu Optima</div>
            <div style={{ fontSize: '10px', color: 'var(--text-muted)' }}>Stany i ceny zakupu z XLS</div>
          </div>
          <input ref={optimaInputRef} type="file" accept=".xls,.xlsx" style={{ display: 'none' }}
            onChange={e => { handleOptimaUpload(e.target.files[0]); e.target.value = ''; }} />
          <button style={{
            padding: '4px 10px', fontSize: '11px', border: '1px solid var(--success)',
            color: 'var(--success)', cursor: 'pointer', fontWeight: '500'
          }}>Import</button>
        </div>

        {/* Import SFD - UKRYTY */}
        <div style={{
          backgroundColor: 'var(--card-bg)', padding: '0.75rem', borderRadius: '4px',
          boxShadow: '0 1px 2px rgba(0,0,0,0.08)', borderLeft: '3px solid var(--danger)',
          display: 'none'
        }} onClick={() => sfdInputRef.current?.click()}>
          <div style={{ fontSize: '1.5rem' }}>🏭</div>
          <div style={{ flex: 1 }}>
            <div style={{ fontWeight: '600', fontSize: '12px' }}>Import SFD (OSOZ-EDI)</div>
            <div style={{ fontSize: '10px', color: 'var(--text-muted)' }}>Faktury XML z SFD/KAMSOFT</div>
          </div>
          <input ref={sfdInputRef} type="file" accept=".xml" style={{ display: 'none' }}
            onChange={e => { handleSfdUpload(e.target.files[0]); e.target.value = ''; }} />
          <button style={{
            padding: '4px 10px', fontSize: '11px', border: '1px solid var(--danger)',
            color: 'var(--danger)', cursor: 'pointer', fontWeight: '500'
          }}>Import</button>
        </div>
        </div>
        )}
      </div>
    </div>
  );
};

export default ImportPanel;
